import { useId, type InputHTMLAttributes, type ReactNode, type Ref } from 'react';

interface FieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'className' | 'id'> {
  label: string;
  error?: boolean;
  describedBy?: string;
  trailing?: ReactNode;
  ref?: Ref<HTMLInputElement>;
}

/** Invoerveld met label erboven; foutstaat krijgt een terracotta rand plus een regel eronder. */
export function Field({ label, error = false, describedBy, trailing, ref, ...input }: FieldProps) {
  const id = useId();
  return (
    <div className={`field${error ? ' field--error' : ''}`}>
      <label className="field__label" htmlFor={id}>
        {label}
      </label>
      <div className="row row--between" style={{ gap: 12 }}>
        <input
          {...input}
          ref={ref}
          id={id}
          className="field__input"
          aria-invalid={error || undefined}
          aria-describedby={describedBy}
        />
        {trailing}
      </div>
    </div>
  );
}

interface FieldNoteProps {
  children: ReactNode;
  id?: string;
  marker?: boolean;
}

export function FieldNote({ children, id, marker = false }: FieldNoteProps) {
  return (
    <p className="fieldnote" id={id}>
      {marker ? <span className="fieldnote__marker" aria-hidden /> : null}
      <span>{children}</span>
    </p>
  );
}
